import {Language} from './../../util/lang';
import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {getRoute} from '../../util/tools';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  public lang: string = Language.getCurrentLang();
  public getRoute = getRoute;

  public Languages: object[] = [
    {display: 'ՀԱՅ', code: 'hy'},
    {display: 'ENG', code: 'en'},
    {display: 'РУС', code: 'ru'}
  ];

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
  }

  public changeLanuage(lang: string): void {
    this.translate.use(lang);
    Language.setCurrentLang(lang, true);
  }
}
